import { Box, Divider, List, ListSubheader, styled } from '@mui/material';
import { SidebarMenuItemType } from 'hooks/ui/useSidebarMenuItems';
import NavigationItem from './NavigationItem';

const NavigationHeader = styled(ListSubheader)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.default,
  fontSize: theme.fontSizes.sm,
  lineHeight: '100%',
  padding: theme.spacing(theme.spacingSizes.xs, theme.spacingSizes.sm),
  textTransform: 'uppercase',
  fontWeight: theme.typography.fontWeightRegular,
}));

const NavigationDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(theme.spacingSizes.xs, 0),
}));

type Props = {
  menuItems: Array<SidebarMenuItemType>;
};

const Navigation: React.FC<Props> = ({ menuItems }) => {
  return (
    <Box>
      {menuItems.map((item, index) =>
        item.type === 'section' ? (
          <List
            key={item.name}
            subheader={
              <NavigationHeader disableSticky>{item.name}</NavigationHeader>
            }
          >
            {item.children?.map((child) => (
              <NavigationItem key={child.name} {...child} />
            ))}
            {index !== menuItems.length - 1 && <NavigationDivider />}
          </List>
        ) : (
          <List key={item.name}>
            <NavigationItem key={item.name} {...item} />
          </List>
        ),
      )}
    </Box>
  );
};

export default Navigation;
